import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

type UserRoleRequiredOwnProps = {
  admin?: boolean;
  rep?: boolean;
  user?: boolean;
  children?: ReactNode;
};

type UserRoleRequiredStateProps = {
  userRoles: RootReduxState['user']['info']['roles'];
};

type UserRoleRequiredProps = UserRoleRequiredOwnProps & UserRoleRequiredStateProps;

class UserRoleRequired extends Component<UserRoleRequiredProps> {
  render() {
    const adminRequired = this.props.admin;
    const repRequired = this.props.rep;
    const userRequired = this.props.user;

    const isAdmin = this.props.userRoles.indexOf('admin') > -1;
    const isRep = this.props.userRoles.indexOf('rep') > -1;
    const isUser = this.props.userRoles.indexOf('user') > -1;

    if (adminRequired && isAdmin) {
      return this.props.children;
    } else if (repRequired && isRep) {
      return this.props.children;
    } else if (userRequired && isUser) {
      return this.props.children;
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: RootReduxState): UserRoleRequiredStateProps => {
  return {
    userRoles: state.user.info.roles,
  };
};

export default connect(mapStateToProps)(UserRoleRequired);
